function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("fullcalendar")) : "function" == typeof define && define.amd ? define(["fullcalendar"], t) : t("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("fullcalendar") : e.FullCalendar);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 127);
  }({
    0: function _(t, n) {
      t.exports = e;
    },
    127: function _(e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n(0).defineLocale("ro", {
        week: {
          dow: 1,
          doy: 7
        },
        buttonText: {
          prev: "precedentă",
          next: "următoare",
          today: "Azi",
          month: "Lună",
          week: "Săptămână",
          day: "Zi",
          list: "Agendă"
        },
        weekLabel: "Săpt",
        allDayText: "Toată ziua",
        eventLimitText: function eventLimitText(e) {
          return "+alte " + e;
        },
        noEventsMessage: "Nu există evenimente de afișat"
      });
    }
  });
});